import { render, staticRenderFns } from "./yyzj.vue?vue&type=template&id=f68c4c18&scoped=true"
import script from "./yyzj.vue?vue&type=script&lang=js"
export * from "./yyzj.vue?vue&type=script&lang=js"
import style0 from "./yyzj.vue?vue&type=style&index=0&id=f68c4c18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68c4c18",
  null
  
)

export default component.exports